import { createSlice } from "@reduxjs/toolkit"

const initialState = {}

const translationsSlice = createSlice({
  name: "translations",
  initialState,
  reducers: {
    setTranslations: (state, action) => {
      // Merge the payload into state
      return { ...state, ...action.payload }
    }
  }
})

export const { setTranslations } = translationsSlice.actions
export default translationsSlice.reducer
